import { UserIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const SingleUser = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <UserIcon size={Sizes[size]} {...rest} color={fill} />;
};

SingleUser.displayName = 'SingleUser';
